import React from 'react'

export const Chevron = ({ className }) => (
  <svg role="presentation" viewBox="0 0 614 1024" className={className}>
    <path d="M508.201-2.299c-8.907 0.365-16.581 3.928-24.027 11.237l-8.77 8.588-459.756 459.711c-8.588 8.633-13.338 20.099-13.338 32.295s4.751 23.662 13.338 32.295l468.709 468.572c7.491 7.354 15.165 10.917 24.21 11.283 7.902 0.32 20.007-7.035 33.117-20.144 8.542-8.588 16.81-17.632 24.529-26.95 1.919-2.33 3.563-4.431 5.070-6.349l-22.657-22.611-436.049-436.095 458.386-458.386c-1.507-1.919-3.198-4.065-5.116-6.395-7.674-9.273-15.942-18.317-24.484-26.859-13.11-13.155-25.215-20.51-33.163-20.19z"/>
  </svg>
)

export const MenuIcon = ({ className }) => (
  <svg role="presentation" className={className} viewBox="0 0 1024 1024">
    <path d="M0 852.329h1024v-114.447h-1024v114.447zM0 569.224h1024v-114.447h-1024v114.447zM0 171.671v114.447h1024v-114.447h-1024z" />
  </svg>
)

export const CloseIcon = ({ className }) => (
  <svg role="presentation" className={className} viewBox="0 0 357 357">
    <path d="M357 35.7L321.3 0 178.5 142.8 35.7 0 0 35.7l142.8 142.8L0 321.3 35.7 357l142.8-142.8L321.3 357l35.7-35.7-142.8-142.8" />
  </svg>
)

export const SearchIcon = ({ className }) => (
  <svg role="presentation" className={className} viewBox="0 0 1024 1024">
    <path d="M995.2 902.4l-214.4-214.4c51.2-70.4 76.8-150.4 76.8-243.2 0-230.4-188.8-419.2-419.2-419.2s-422.4 185.6-422.4 416c0 233.6 188.8 422.4 419.2 422.4 96 0 185.6-35.2 259.2-89.6l163.2 163.2c3.2 3.2 3.2 3.2 6.4 3.2l41.6 41.6 89.6-80zM435.2 768c-176 0-320-144-320-320s144-320 320-320c176 0 320 144 320 320 0 73.6-25.6 144-64 195.2-16 19.2-32 35.2-44.8 51.2-57.6 44.8-131.2 73.6-211.2 73.6v0z" />
  </svg>
)

export const WhatsAppIcon = ({ className }) => (
  <svg role="presentation" className={className} viewBox="0 0 32 32">
    <path d="M27.281 4.65c-2.994-3-6.975-4.65-11.219-4.65-8.738 0-15.85 7.112-15.85 15.856 0 2.794 0.731 5.525 2.119 7.925l-2.25 8.219 8.406-2.206c2.319 1.262 4.925 1.931 7.575 1.931h0.006c0 0 0 0 0 0 8.738 0 15.856-7.113 15.856-15.856 0-4.238-1.65-8.219-4.644-11.219zM16.069 29.050v0c-2.369 0-4.688-0.637-6.713-1.837l-0.481-0.288-4.987 1.306 1.331-4.863-0.313-0.5c-1.325-2.094-2.019-4.519-2.019-7.012 0-7.269 5.912-13.181 13.188-13.181 3.519 0 6.831 1.375 9.319 3.862 2.488 2.494 3.856 5.8 3.856 9.325-0.006 7.275-5.919 13.188-13.181 13.188zM23.294 19.175c-0.394-0.2-2.344-1.156-2.706-1.288s-0.625-0.2-0.894 0.2c-0.262 0.394-1.025 1.288-1.256 1.556-0.231 0.262-0.462 0.3-0.856 0.1s-1.675-0.619-3.188-1.969c-1.175-1.050-1.975-2.35-2.206-2.744s-0.025-0.613 0.175-0.806c0.181-0.175 0.394-0.463 0.594-0.694s0.262-0.394 0.394-0.662c0.131-0.262 0.069-0.494-0.031-0.694s-0.894-2.15-1.219-2.944c-0.319-0.775-0.65-0.669-0.894-0.681-0.231-0.012-0.494-0.012-0.756-0.012s-0.694 0.1-1.056 0.494c-0.363 0.394-1.387 1.356-1.387 3.306s1.419 3.831 1.619 4.1c0.2 0.262 2.794 4.269 6.769 5.981 0.944 0.406 1.681 0.65 2.256 0.837 0.95 0.3 1.813 0.256 2.494 0.156 0.762-0.113 2.344-0.956 2.675-1.881s0.331-1.719 0.231-1.881c-0.094-0.175-0.356-0.275-0.756-0.475z" />
  </svg>
)

export const TwitterIcon = ({ className }) => (
  <svg role="presentation" className={className} viewBox="0 0 32 32">
    <path d="M32 7.075c-1.175 0.525-2.444 0.875-3.769 1.031 1.356-0.813 2.394-2.1 2.887-3.631-1.269 0.75-2.675 1.3-4.169 1.594-1.2-1.275-2.906-2.069-4.794-2.069-3.625 0-6.563 2.938-6.563 6.563 0 0.512 0.056 1.012 0.169 1.494-5.456-0.275-10.294-2.888-13.531-6.862-0.563 0.969-0.887 2.1-0.887 3.3 0 2.275 1.156 4.287 2.919 5.463-1.075-0.031-2.087-0.331-2.975-0.819 0 0.025 0 0.056 0 0.081 0 3.181 2.263 5.838 5.269 6.437-0.55 0.15-1.131 0.231-1.731 0.231-0.425 0-0.831-0.044-1.237-0.119 0.838 2.606 3.263 4.506 6.131 4.563-2.25 1.762-5.075 2.813-8.156 2.813-0.531 0-1.050-0.031-1.569-0.094 2.913 1.869 6.362 2.95 10.069 2.95 12.075 0 18.681-10.006 18.681-18.681 0-0.287-0.006-0.569-0.019-0.85 1.281-0.919 2.394-2.075 3.275-3.394z" />
  </svg>
)

export const FacebookIcon = ({ className }) => (
  <svg role="presentation" className={className} viewBox="0 0 32 32">
    <path d="M19 6h5v-6h-5c-3.86 0-7 3.14-7 7v3h-4v6h4v16h6v-16h5l1-6h-6v-3c0-0.542 0.458-1 1-1z" />
  </svg>
)

export const InstagramIcon = ({ className }) => (
  <svg role="presentation" className={className} viewBox="0 0 512 512">
    <path d="M336 96c21.2 0 41.3 8.4 56.5 23.5S416 154.8 416 176v160c0 21.2-8.4 41.3-23.5 56.5S357.2 416 336 416H176c-21.2 0-41.3-8.4-56.5-23.5S96 357.2 96 336V176c0-21.2 8.4-41.3 23.5-56.5S154.8 96 176 96h160m0-32H176c-61.6 0-112 50.4-112 112v160c0 61.6 50.4 112 112 112h160c61.6 0 112-50.4 112-112V176c0-61.6-50.4-112-112-112z"/>
    <path d="M360 176c-13.3 0-24-10.7-24-24s10.7-24 24-24c13.2 0 24 10.7 24 24s-10.8 24-24 24zM256 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64m0-32c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"/>
  </svg>
)

export const EmailIcon = ({ className }) => (
  <svg role="presentation" className={className} viewBox="0 0 32 32">
    <path d="M29 4h-26c-1.657 0-3 1.343-3 3v18c0 1.656 1.343 3 3 3h26c1.657 0 3-1.344 3-3v-18c0-1.657-1.343-3-3-3zM2.741 25.99l-0.731-0.732 8.249-8.248 0.731 0.732-8.249 8.248zM29.259 25.99l-8.249-8.248 0.731-0.732 8.249 8.248-0.731 0.732zM17 19.325v0.675h-2v-0.675l-12.997-12.050 1.272-1.272 12.725 11.798 12.725-11.798 1.272 1.272-12.997 12.050z" />
  </svg>
)

export const UserIcon = ({ className }) => (
   <svg role="presentation"  className={ className } viewBox="0 0 26 26">
      <path d="M13 2.71c-1.775 0-3.22 1.445-3.22 3.22 0 1.775 1.445 3.22 3.22 3.22 1.775-.002 3.218-1.446 3.218-3.22 0-1.775-1.443-3.22-3.218-3.22m0 8.438c-2.878 0-5.22-2.34-5.22-5.218C7.78 3.053 10.123.71 13 .71c2.877 0 5.22 2.343 5.22 5.22s-2.343 5.22-5.22 5.22M3.61 23.29h18.78c-1.61-3.683-5.298-6.157-9.39-6.157-4.09 0-7.78 2.474-9.39 6.156zm21.525 2H.865l.365-1.276c1.495-5.23 6.334-8.88 11.77-8.88s10.276 3.65 11.77 8.88l.365 1.275z" />
  </svg>
)

export const TrashIcon = ({ className }) => (
  <svg role="presentation" className={ className } viewBox='0 0 30 30'>
    <g id="Symbols" stroke="none" strokeWidth="1" fill="#fff" fillRule="evenodd">
        <g id="icon-trash" stroke="#000">
            <g id="Group-4" transform="translate(5.000000, 5.000000)">
                <rect id="Rectangle-4" x="7.5" y="0.5" width="6" height="3"></rect>
                <rect id="Rectangle-4" x="3.5" y="3.5" width="14" height="17"></rect>
                <path d="M0.5,3.5 L20.5,3.5" id="Line" strokeLinecap="square"></path>
                <path d="M7.5,7.5 L7.5,16.5" id="Line" strokeLinecap="square"></path>
                <path d="M10.5,7.5 L10.5,16.5" id="Line" strokeLinecap="square"></path>
                <path d="M13.5,7.5 L13.5,16.5" id="Line" strokeLinecap="square"></path>
            </g>
        </g>
    </g>
  </svg>
)


export const RemoveFromFavoritesIcon = ({ className }) => (
  <svg role="presentation" className={className} viewBox="0 0 59.02 49.11">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_2-2" data-name="Layer 2">
        <g id="oAFm60">
          <path style={{ fill: '#db0000', strokeLinecap: 'round', strokeLinejoin: 'bevel', strokeWidth: '3.95px' }} d="M29,10.86c.16-.38.27-.68.4-1A12.32,12.32,0,0,1,38,2.73a16,16,0,0,1,8.57-.15,13.1,13.1,0,0,1,9.24,8.82A21.22,21.22,0,0,1,57,16.68,15.19,15.19,0,0,1,55.17,25a35.39,35.39,0,0,1-7,9.07,73.63,73.63,0,0,1-14.13,10.5c-1.65,1-3.33,1.91-5,2.87C27,46.16,24.93,45,22.92,43.7a69.32,69.32,0,0,1-12-9.33A35.3,35.3,0,0,1,3.53,24.31,15.55,15.55,0,0,1,2,16.94,22.23,22.23,0,0,1,3.33,10.7,12.88,12.88,0,0,1,17.11,2.05a16.33,16.33,0,0,1,5,1.21A12.06,12.06,0,0,1,29,10.86Z"/>
        </g>
      </g>
    </g>
  </svg>
)

export const AddToFavoritesIcon = ({ className }) => (
  <svg role="presentation" className={className} viewBox="0 0 59.02 49.11">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_2-2" data-name="Layer 2">
        <g id="oAFm60">
          <path style={{fill: 'none', stroke: 'white', strokeLinecap: 'round', strokeLinejoin: 'bevel', strokeWidth: '3.95px' }} d="M29,10.86c.16-.38.27-.68.4-1A12.32,12.32,0,0,1,38,2.73a16,16,0,0,1,8.57-.15,13.1,13.1,0,0,1,9.24,8.82A21.22,21.22,0,0,1,57,16.68,15.19,15.19,0,0,1,55.17,25a35.39,35.39,0,0,1-7,9.07,73.63,73.63,0,0,1-14.13,10.5c-1.65,1-3.33,1.91-5,2.87C27,46.16,24.93,45,22.92,43.7a69.32,69.32,0,0,1-12-9.33A35.3,35.3,0,0,1,3.53,24.31,15.55,15.55,0,0,1,2,16.94,22.23,22.23,0,0,1,3.33,10.7,12.88,12.88,0,0,1,17.11,2.05a16.33,16.33,0,0,1,5,1.21A12.06,12.06,0,0,1,29,10.86Z"/>
        </g>
      </g>
    </g>
  </svg>
)

export const FollowHeartIcon = ({className}) => (
  <svg className={className} width="21px" height="19px" viewBox="0 0 21 19" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="key-screens" stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
          <g id="Web-CONCEPT-DETAIL-S" transform="translate(-256.000000, -67.000000)">
              <rect fill="#0D0D0D" x="0" y="0" width="320" height="1524"></rect>
              <g id="top" transform="translate(0.000000, 56.000000)" fill="#FFFFFF" stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round">
                  <g id="icon/follow-selected" transform="translate(257.000000, 12.000000)">
                      <path d="M9.50001414,18 L1.66337777,10.0308293 C0.579945956,8.92843902 -0.0263267717,7.37385366 0.000877773777,5.76614634 C0.018150501,2.71492683 2.48987777,0.257268293 5.52642323,0.257268293 C7.00453686,0.257268293 8.42737777,0.895609756 9.49958232,2.02478049 C10.5726505,0.895609756 11.996355,0.257268293 13.473605,0.257268293 C16.5192187,0.257268293 18.9969914,2.73029268 18.9991505,5.76965854 C19.0250596,7.3764878 18.4192187,8.92931707 17.3362187,10.0308293 L9.50001414,18 Z"></path>
                  </g>
              </g>
          </g>
      </g>
  </svg>
)

export const AddToWatchlistIcon = ({ className }) => (
  <svg role="presentation" className={ className } viewBox="0 0 40 40">
    <defs>
        <circle id="path-1" cx="20" cy="20" r="20"></circle>
    </defs>
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Buttons/watchlist">
            <g id="Group-2">
                <g id="Oval-5">
                    <use fillOpacity="0.75" fillRule="evenodd" xlinkHref="#path-1"></use>
                    <circle stroke="currentColor" strokeWidth="2" cx="20" cy="20" r="19"></circle>
                </g>
                <polygon id="Combined-Shape" fill="currentColor" points="22.0650107 17.9266945 22.0650107 9.48854866 17.9349893 9.48854866 17.9349893 17.9266945 9.60467529 17.9266945 9.60467529 22.0733055 17.9349893 22.0733055 17.9349893 30.5114513 22.0650107 30.5114513 22.0650107 22.0733055 30.3953247 22.0733055 30.3953247 17.9266945"></polygon>
            </g>
        </g>
    </g>
  </svg>
)

export const RemoveFromWatchlistIcon = ({ className }) => (
  <svg role="presentation" className={ className } viewBox="0 0 40 40">
    <defs>
      <circle id="b" cx="20" cy="20" r="20"/>
      <filter id="a" width="137.5%" height="137.5%" x="-11.2%" y="-13.7%" filterUnits="objectBoundingBox">
        <feOffset dx="3" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
        <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
        <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.225600091 0" in="shadowBlurOuter1"/>
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <use filter="url(#a)" xlinkHref="#b"/>
      <use fillOpacity=".75" xlinkHref="#b"/>
      <circle cx="20" cy="20" r="19" stroke="currentColor" strokeWidth="2"/>
      <path fill="currentColor" d="M9.605 17.927v4.146h20.79v-4.146"/>
    </g>
  </svg>
)

export const BackArrowIcon = ({ className }) => (
  <svg width="14px" height="10px" viewBox="0 0 14 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="key-screens" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Web-CONCEPT-DETAIL-S" transform="translate(-13.000000, -70.000000)">
              <rect fill="#0D0D0D" x="0" y="0" width="320" height="1524"></rect>
              <g id="top" transform="translate(0.000000, 56.000000)" stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round">
                  <g id="icon/back" transform="translate(14.000000, 14.000000)">
                      <g transform="translate(0.000000, 0.500000)" id="Shape">
                          <path d="M12.5,4.75 L0,4.75"></path>
                          <polyline points="4.6875 9.5 0 4.75 4.6875 0"></polyline>
                      </g>
                  </g>
              </g>
          </g>
      </g>
  </svg>
)

export const TriangleIcon = ({ className, color }) => (
  <svg role="presentation" className={ className } width="20px" height="10px" viewBox="0 0 20 10">
    <g id="WebApps-No-Playlist" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="W01-Home-Loggedin" transform="translate(-943.000000, -46.000000)" fill={color || "#FFFFFF"}>
            <g id="Group-4" transform="translate(50.000000, 15.000000)">
                <g id="Group-2" transform="translate(354.000000, 22.000000)">
                    <polygon id="Triangle" points="549 19 539 9 559 9"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>
)

export const CalendarIcon = ({ className }) => (
  <svg role="presentation" className={ className } width="21px" height="24px" viewBox="0 0 21 24" version="1.1">
    <g id="Symbols" stroke="none" strokeWidth="2" fill="none" fillRule="evenodd">
      <g id="icon-/-calendar" transform="translate(-1.000000, 0.000000)">
        <g id="calendar" transform="translate(2.000000, 1.000000)">
          <path d="M2,2 L16,2 C17.1045695,2 18,2.8954305 18,4 C18,6.69637044 18,9.39274089 18,12.0891113 C18,14.0594076 18,16.0297038 18,18 L18,18 C18,19.1045695 17.1045695,20 16,20 C13.634196,20 11.2683919,20 8.90258789,20 C6.60172526,20 4.30086263,20 2,20 L2,20 C0.8954305,20 1.3527075e-16,19.1045695 0,18 L0,4 C-1.3527075e-16,2.8954305 0.8954305,2 2,2 Z" id="Rectangle-path" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
          <rect id="Rectangle" fill="#222222" x="10" y="13" width="10" height="10"></rect>
          <path d="M13,0 L13,4" id="Shape1" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
          <path d="M5,0 L5,4" id="Shape2" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
          <path d="M0,8 L18,8" id="Shape3" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
          <path d="M13,18 L17,18" id="Shape-Copy1" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round"></path>
          <path d="M15,16 L15,20" id="Shape-Copy2" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round"></path>
        </g>
      </g>
    </g>
  </svg>
)

export const TimerSVG = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.48 60.05">
    <defs></defs>
    <title>timer</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path className="cls-1" fill="#ed1c24" d="M32,0H21.89a2,2,0,0,0-2,2h0a2,2,0,0,0,2,2h.23l.08,1.9A23.14,23.14,0,0,1,32,6V3.93h0a2,2,0,0,0,2-2h0A2,2,0,0,0,32,0Z" />
        <path className="cls-1" fill="none" stroke="#ed1c24" strokeMiterlimit="10" strokeWidth="2.32px" d="M9,10.37l-.92-1,.2-.21A1.53,1.53,0,0,0,8.29,7l-.11-.11A1.53,1.53,0,0,0,6,6.91L1.45,11.49a1.51,1.51,0,0,0,0,2.15l.11.12a1.52,1.52,0,0,0,1.93.17l.86.92a1.81,1.81,0,0,0,.3,1.77,46.13,46.13,0,0,1,6.08-6A1.88,1.88,0,0,0,9,10.37Z" />
        <path className="cls-1" fill="none" stroke="#ed1c24" strokeMiterlimit="10" strokeWidth="2.32px" d="M52.49,11.49,47.9,6.91a1.53,1.53,0,0,0-2.15,0L45.64,7a1.53,1.53,0,0,0,0,2.15l.21.21-.93,1a1.86,1.86,0,0,0-1.71.24,46.39,46.39,0,0,1,6.07,6,1.83,1.83,0,0,0,.31-1.77l.85-.92a1.53,1.53,0,0,0,1.94-.17l.11-.12A1.53,1.53,0,0,0,52.49,11.49Z" />
        <path className="cls-2" fill="none" stroke="#ed1c24" strokeMiterlimit="10" strokeWidth="2.32px" d="M26.74,7.73A25.58,25.58,0,1,0,52.32,33.31,25.58,25.58,0,0,0,26.74,7.73Z" />
      </g>
    </g>
  </svg>
)

export const FiltersSVG = ({className}) => (
  <svg  className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68.07 48.79">
    <title>menu-filter</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_4" data-name="Layer 4">
        <circle cx="12.88" cy="7.36" r="7.36" />
        <circle cx="53.22" cy="24.53" r="7.36" />
        <circle cx="27.6" cy="41.43" r="7.36" />
        <rect y="4.91" width="68.07" height="5.52" />
        <rect y="21.46" width="68.07" height="5.52" />
        <rect y="38.02" width="68.07" height="5.52" />
      </g>
    </g>
  </svg>
)

export const Bookmark = ({className}) => (
  <svg className={className} width="18px" height="22px" viewBox="0 0 18 22" xmlns="http://www.w3.org/2000/svg">
      <g id="Symbols" stroke="none" strokeWidth="1">
          <g id="class-row/browse-S" transform="translate(-280.000000, -5.000000)">
              <rect fill="#0D0D0D" x="0" y="0" width="320" height="81"></rect>
              <g id="2" stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round">
                  <g id="icon/bookmark" transform="translate(281.000000, 5.000000)">
                      <path d="M15.9571427,20.6562497 L8.1,15.1006942 L0.24285725,20.6562497 L0.24285725,2.87847219 C0.24285725,1.65117276 1.24793229,0.65625 2.48775518,0.65625 L13.7122448,0.65625 C14.9520677,0.65625 15.9571427,1.65117276 15.9571427,2.87847219 L15.9571427,20.6562497 Z"></path>
                  </g>
              </g>
          </g>
      </g>
  </svg>
)
export const ThumbIcon = ({className}) => (
  <svg className={className} width="20px" height="20px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="key-screens" stroke="none" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
          <g id="Web-VIDEO-DETAIL-M" transform="translate(-197.000000, -430.000000)" stroke="#FFFFFF">
              <g id="title" transform="translate(20.000000, 365.000000)">
                  <g id="rating" transform="translate(177.000000, 66.000000)">
                      <g id="thumbs-up-XS-quiet" transform="translate(0.500000, 0.000000)">
                          <g id="thumbs-up">
                              <path d="M8.4,4.9 L8.4,2.1 C8.4,0.940202025 7.45979797,1.77635684e-16 6.3,-4.4408921e-16 L3.5,6.3 L3.5,14.0000908 L11.396,14 C12.0941007,14.0078921 12.6913228,13.5002533 12.796,12.81 L13.762,6.51 C13.8236392,6.10389872 13.703828,5.69121616 13.434301,5.38126004 C13.1647739,5.07130391 12.7727262,4.89534875 12.362,4.9 L8.4,4.9 Z M3.5,14 L1.4,14 C0.62680135,14 0,13.3731986 0,12.6 L0,7.7 C-1.55431223e-16,6.92680135 0.62680135,6.3 1.4,6.3 L3.5,6.3 L3.5,14 Z" id="Shape"></path>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </g>
  </svg>
)
      
export const ClockIcon = ({className}) => (
  <svg width="20px" height="20px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="key-screens" stroke="none" strokeWidth="1">
          <g id="Web-VIDEO-DETAIL-M" transform="translate(-109.000000, -430.000000)">
              <rect fill="#0D0D0D" x="0" y="0" width="768" height="1283"></rect>
              <g id="title" transform="translate(20.000000, 365.000000)" fill="#FFFFFF">
                  <g id="duration" transform="translate(89.000000, 65.000000)">
                      <g id="icon/clock">
                          <g id="clock">
                              <path d="M7.5,15 C11.6404358,15 15,11.6404358 15,7.5 C15,3.35956416 11.6404358,0 7.5,0 C3.35956416,0 0,3.35956416 0,7.5 C0,11.6404358 3.35956416,15 7.5,15 Z M7.5,1.05326877 C11.059322,1.05326877 13.9467312,3.94067797 13.9467312,7.5 C13.9467312,11.059322 11.059322,13.9467312 7.5,13.9467312 C3.94067797,13.9467312 1.05326877,11.059322 1.05326877,7.5 C1.05326877,3.94067797 3.94067797,1.05326877 7.5,1.05326877 Z" id="Shape" fillRule="nonzero"></path>
                              <path d="M6.77965966,8.53340793 L9.40531736,10.2117967 C9.5040263,10.2789322 9.62247702,10.3125 9.74092774,10.3125 C9.91860383,10.3125 10.0962799,10.2453645 10.1949888,10.1110934 C10.3924067,9.89290281 10.3331814,9.59079284 10.0765381,9.42295396 L7.70752366,7.91240409 L7.70752366,4.23673274 C7.70752366,3.96819054 7.45088043,3.75 7.13501183,3.75 C6.81914323,3.75 6.5625,3.96819054 6.5625,4.23673274 L6.5625,8.14737852 C6.5625,8.2984335 6.64146715,8.44948849 6.77965966,8.53340793 Z" id="Path"></path>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </g>
  </svg>
)

export const CalendarIconNEOU = ({ className }) => (
  <svg className={className} width="24px" height="25px" viewBox="0 0 24 25" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Symbols" stroke="none" strokeWidth="1">
          <g id="class-row/M" transform="translate(-707.000000, -32.000000)" stroke="#FFFFFF">
              <g id="2">
                  <g id="icon/add-to-calendar" transform="translate(707.000000, 32.000000)">
                      <g>
                          <rect id="Rectangle" x="1" y="2.5" width="17" height="17" rx="2.5"></rect>
                          <path d="M5.17142857,0.885547201 L5.17142857,4" id="Line-3" strokeLinecap="round" strokeLinejoin="round"></path>
                          <path d="M13.8,0.885547201 L13.8,4" id="Line-3-Copy" strokeLinecap="round" strokeLinejoin="round"></path>
                          <path d="M1.84615385,7 L17.8461538,7" id="Line-4" strokeLinecap="square"></path>
                          <g id="Group-4" transform="translate(9.000000, 10.473517)">
                              <circle id="Oval" fill="#0D0D0D" cx="6.76257324" cy="7.23742676" r="6.76257324"></circle>
                              <path d="M6.76257324,7.23742676 L3.76257324,7.23742676 L6.76257324,7.23742676 L6.76257324,4.23742676 L6.76257324,7.23742676 Z M6.76257324,7.23742676 L9.76257324,7.23742676 L6.76257324,7.23742676 L6.76257324,10.2374268 L6.76257324,7.23742676 Z" id="Combined-Shape" strokeLinecap="round" strokeLinejoin="round"></path>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </g>
  </svg>
)

export const ShareIcon = ({className}) => (
  <svg className={className} width="14px" height="17px" viewBox="0 0 14 17" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="key-screens" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Web-CONCEPT-DETAIL-S" transform="translate(-293.000000, -68.000000)">
              <rect fill="#0D0D0D" x="0" y="0" width="320" height="1524"></rect>
              <g id="top" transform="translate(0.000000, 56.000000)" stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round">
                  <g id="icon/share" transform="translate(294.000000, 12.000000)">
                      <g transform="translate(0.400000, 0.800000)" id="Shape">
                          <path d="M0,7.6 L0,13.68 C0,14.5194728 0.671572875,15.2 1.5,15.2 L10.5,15.2 C11.3284271,15.2 12,14.5194728 12,13.68 L12,7.6"></path>
                          <polyline points="9 3.04 6 0 3 3.04"></polyline>
                          <path d="M6,0 L6,9.88"></path>
                      </g>
                  </g>
              </g>
          </g>
      </g>
  </svg>
)

export const PlayIconSmall = ({className}) => (
  <svg width="37px" height="37px" viewBox="0 0 37 37" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Symbols" stroke="none" strokeWidth="1">
          <g id="video-thumbnail" transform="translate(-95.000000, -45.000000)">
              <g transform="translate(0.500000, 0.000000)" id="component/play">
                  <g transform="translate(96.000000, 46.500000)">
                      <g transform="translate(0.292308, 0.000000)">
                          <circle id="Oval" stroke="#FFFFFF" fill="#0D0D0D" opacity="0.65" cx="17" cy="17" r="17.5"></circle>
                          <path d="M23.5325734,17.5875383 L13.1687214,24.0607259 C12.9345103,24.2070125 12.626056,24.1357356 12.4797694,23.9015245 C12.4301529,23.8220863 12.4038462,23.7303093 12.4038462,23.6366492 L12.4038462,10.6902739 C12.4038462,10.4141315 12.6277038,10.1902739 12.9038462,10.1902739 C12.9975062,10.1902739 13.0892833,10.2165807 13.1687214,10.2661972 L23.5325734,16.7393848 C23.7667845,16.8856714 23.8380614,17.1941257 23.6917748,17.4283368 C23.6515009,17.492817 23.5970536,17.5472644 23.5325734,17.5875383 Z" id="Shape" fill="#FFFFFF"></path>
                      </g>
                  </g>
              </g>
          </g>
      </g>
  </svg>
)

export const PlayIconLarge = ({className}) => (
  <svg width="67px" height="67px" viewBox="0 0 67 67" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="library" stroke="none" strokeWidth="1">
        <g id="Icons" transform="translate(-154.000000, -1138.000000)">
            <g transform="translate(59.000000, 206.000000)">
                <g transform="translate(1.000000, 900.000000)">
                    <g id="component/play-large" transform="translate(94.000000, 32.000000)">
                        <g transform="translate(0.907692, 0.500000)">
                            <circle id="Oval" stroke="#FFFFFF" fill="#0D0D0D" opacity="0.65" cx="32.7692308" cy="32.6923077" r="32.5"></circle>
                            <path d="M43.1716252,33.8384436 L27.5449884,43.9957576 C27.0819287,44.2967463 26.4625451,44.1653619 26.1615564,43.7023023 C26.0561197,43.540092 26,43.3507799 26,43.157314 L26,22.842686 C26,22.2904013 26.4477153,21.842686 27,21.842686 C27.1934659,21.842686 27.3827781,21.8988058 27.5449884,22.0042424 L43.1716252,32.1615564 C43.6346848,32.4625451 43.7660692,33.0819287 43.4650805,33.5449884 C43.3888594,33.6622516 43.2888884,33.7622225 43.1716252,33.8384436 Z" id="Shape" fill="#FFFFFF"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
)

export const LoadingIcon = ({className}) => (
  <svg className="loading-icon" width="51px" height="50px" viewBox="0 0 51 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="library" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <g id="Icons" transform="translate(-611.000000, -1146.000000)" stroke="#FFFFFF" strokeWidth="2">
              <g id="🌀-UI" transform="translate(59.000000, 206.000000)">
                  <g id="📄-loading" transform="translate(452.000000, 900.000000)">
                      <g id="icon/loading-2x" transform="translate(101.600000, 41.000000)">
                          <path d="M24,0 C10.745166,0 0,10.745166 0,24 M24,48 C37.254834,48 48,37.254834 48,24"></path>
                      </g>
                  </g>
              </g>
          </g>
      </g>
  </svg>
)

export const FullScreenIcon = ({className}) => (
  <svg className={className} width="17px" height="17px" viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="key-screens" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <g id="Web-VIDEO-PLAYER-inline-L" transform="translate(-548.000000, -394.000000)" stroke="#FFFFFF">
              <g id="video-controls" transform="translate(38.000000, 128.000000)">
                  <g id="full-screen" transform="translate(518.084057, 274.766311) rotate(-315.000000) translate(-518.084057, -274.766311) translate(507.084057, 269.766311)">
                      <g id="&lt;" transform="translate(0.414214, 0.000000)">
                          <path d="M8.08586239,4.5 L1,4.5" id="Shape"></path>
                          <polyline id="Shape" points="4.5 9.12 0 4.56 4.5 0"></polyline>
                      </g>
                      <g id="&gt;" transform="translate(17.085786, 5.000000) scale(-1, 1) translate(-17.085786, -5.000000) translate(12.585786, -0.000000)">
                          <path d="M8.24955586,4.56 L1.24955586,4.56" id="Shape"></path>
                          <polyline id="Shape" points="4.5 9.12 9.09494702e-13 4.56 4.5 -1.41842094e-12"></polyline>
                      </g>
                  </g>
              </g>
          </g>
      </g>
  </svg>
)

export const ExitFullScreenIcon = ({className}) => (
  <svg className={className} width="17px" height="17px" viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="key-screens" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <g id="Web-VIDEO-PLAYER-fullscreen-L" transform="translate(-977.000000, -623.000000)" stroke="#FFFFFF">
              <g id="video-controls" transform="translate(28.000000, 120.000000)">
                  <g id="inline" transform="translate(957.084057, 511.766311) rotate(-315.000000) translate(-957.084057, -511.766311) translate(945.084057, 506.766311)">
                      <g id="&lt;-copy" transform="translate(14.142136, 0.000000)">
                          <path d="M8.08586239,4.5 L1,4.5" id="Shape"></path>
                          <polyline id="Shape" points="4.5 9.12 0 4.56 4.5 0"></polyline>
                      </g>
                      <g id="&gt;-copy" transform="translate(5.357864, 5.000000) scale(-1, 1) translate(-5.357864, -5.000000) translate(0.857864, 0.000000)">
                          <path d="M8.24955586,4.56 L1.24955586,4.56" id="Shape"></path>
                          <polyline id="Shape" points="4.5 9.12 9.09494702e-13 4.56 4.5 -1.41842094e-12"></polyline>
                      </g>
                  </g>
              </g>
          </g>
      </g>
  </svg>
)

export const CheckmarkIcon = ({className}) => (
  <svg className={className} width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="key-screens" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Web-SetUp-Profile-M" transform="translate(-238.000000, -613.000000)">
              <rect fill="#0D0D0D" x="0" y="0" width="768" height="866"></rect>
              <g id="lightbox" transform="translate(148.000000, 83.500000)">
                  <g id="Group-2">
                      <g id="icon/check-select" transform="translate(87.000000, 526.000000)">
                          <g transform="translate(3.000000, 3.000000)">
                              <circle id="Oval" fill="#EA0000" cx="9" cy="9.5" r="9"></circle>
                              <g id="check" transform="translate(4.125000, 7.000000)" stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                  <path d="M0.408325195,2.58358046 L3.59803599,5.77329126" id="Line"></path>
                                  <path d="M3.58399687,-1.13686838e-13 L9.45428467,5.79674229" id="Line" transform="translate(6.519141, 2.898371) scale(-1, 1) translate(-6.519141, -2.898371) "></path>
                              </g>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </g>
  </svg>
)